import React from "react";
import PropTypes from "prop-types";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const BasicPageWrapperNavigationComponent = ({
    currentPage,
    totalPages,
    totalElements,
    itemsPerPage,
    loading,
    show,
    fetchData,
}) => {
    const pages = getPages(currentPage, totalPages);
    if (totalPages === 0) {
        return null;
    }
    if (!loading && show && totalElements >= itemsPerPage) {
        return (
            <>
                <Pagination>
                    {!pages.includes(0) && (
                        <PaginationItem onClick={() => toggleToPage(0, totalPages, fetchData)}>
                            <PaginationLink first />
                        </PaginationItem>
                    )}
                    
                    <PaginationItem
                        onClick={() => {
                            if (currentPage !== 0) {
                                togglePreviousPage(currentPage, fetchData);
                            }
                        }}
                        disabled={currentPage === 0}
                    >
                        <PaginationLink previous />
                    </PaginationItem>

                    {pages.map((item, index) => (
                        <PaginationItem
                            key={index}
                            active={currentPage === item}
                            onClick={() => toggleToPage(item, totalPages, fetchData)}
                        >
                            <PaginationLink>{item + 1}</PaginationLink>
                        </PaginationItem>
                    ))}

                    <PaginationItem
                        disabled={totalPages <= currentPage + 1}
                        onClick={() => {
                            if (totalPages > currentPage + 1) {
                                toggleNextPage(currentPage, totalPages, fetchData);
                            }
                        }}
                    >
                        <PaginationLink next />
                    </PaginationItem>

                    {!pages.includes(totalPages - 1) && (
                        <PaginationItem onClick={() => toggleToPage(totalPages - 1, totalPages, fetchData)}>
                            <PaginationLink last />
                        </PaginationItem>
                    )}
                </Pagination>
            </>
        );
    } else {
        return <></>;
    }

    function toggleNextPage(currentPage, totalPages, fetchData) {
        if (currentPage === undefined) {
            currentPage = 0;
        }
        if (currentPage < totalPages - 1) {
            fetchData({ page: currentPage + 1 });
        }
    }

    function togglePreviousPage(currentPage, fetchData) {
        if (currentPage > 0) {
            fetchData({ page: currentPage - 1 });
        }
    }

    function toggleToPage(pageIndex, totalPages, fetchData) {
        if (pageIndex >= 0 && pageIndex < totalPages) fetchData({ page: pageIndex });
    }

    /**
     * Erstellt ein Array von Nummern, für die Seiten
     * Es geht dabei von aktueller Seite -2 bis aktueller Seite +2
     * Mind. jedoch von 0 bis maximal zur letzten Seite
     * aber immer 5 Seiten, außer es gibt keine 5 Seiten, dann werden immer alle verfügbaren Seiten angegeben
     */
    function getPages(currentPage, totalPages) {
        if (!totalPages === undefined) return;
        const page = currentPage || 0;
        // const length = Math.min(5, total)
        // const min = Math.max(Math.max(0, page-2), total-length)
        let response = [];
        let startI = page;
        if (startI >= 2) {
            startI = startI - 2;
            for (let i = startI; i < 5 + startI; i++) {
                if (i >= totalPages) {
                    break;
                }
                response.push(i);
            }
        } else {
            for (let i = 0; i <= Math.min(totalPages, 5); i++) {
                if (i >= totalPages) {
                    break;
                }
                response.push(i);
            }
        }

        return response;
        // return Array.from({length: length}, (_, k) => k + min)
    }
};

BasicPageWrapperNavigationComponent.propTypes = {
    currentPage: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    totalElements: PropTypes.number.isRequired,
    itemsPerPage: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    show: PropTypes.bool.isRequired,
    fetchData: PropTypes.func.isRequired,
};

export default BasicPageWrapperNavigationComponent;
